import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/common/Layout";
import { trackPrayerStart, trackEvent } from "../../utils/analytics";
import styles from "./MainPage.module.css";

// 이미지 import
import mainTitle from "../../assets/main_title_2026_v3.svg"; // 09-14 v3: G2A'26 워드마크만 레드(#E40039), 도형·크기(350×253)는 v2와 동일 (v2: 09-12 새 락업, 상단 GO2ALL 스트립은 시안대로 제거)
import buttonSvg from "../../assets/button_2026.svg"; // 09-14 유현님 B15 선택: 레드 알약 350×64 + 아이보리 글자 (2025 button.svg는 보존)
import mainHero from "../../assets/main_hero_2026.webp";
import texture from "../../assets/texture.png";

const MainPage = () => {
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // 컴포넌트 마운트 후 약간의 딜레이를 두고 로드 상태로 변경
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleStartClick = () => {
    trackPrayerStart();
    navigate("/loading");
  };

  // 인라인 스타일로 fade 효과 구현
  const fadeStyle = (delay = 0) => ({
    opacity: isLoaded ? 1 : 0,
    transform: isLoaded ? "translateY(0)" : "translateY(30px)",
    transition: `opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) ${delay}s, transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) ${delay}s`,
  });

  const onCaption = () => {
    // GA4 이벤트 추적: 인터파크 배너 클릭
    trackEvent("click_interpark_banner", "external_link", "main_page_banner");
    window.open("https://tickets.interpark.com/goods/26007354", "_blank");
  };

  return (
    <Layout fullHeight className={styles.mainPage}>
      {/* 2026 메인 히어로 배경 (단일 이미지) */}
      <div
        className={`${styles.movingBackgrounds} fade-in ${
          isLoaded ? "loaded" : ""
        }`}
      >
        <div
          className={styles.heroBg}
          style={{ backgroundImage: `url(${mainHero})` }}
        ></div>
      </div>

      {/* 텍스처 오버레이 — 히어로 사진 위, 그라데이션·콘텐츠 아래 (2026 히어로 전환 때 뺐던 것 복구) */}
      <div
        className={styles.textureBackground}
        style={{ backgroundImage: `url(${texture})` }}
      ></div>

      {/* 상단 그라데이션 오버레이 */}
      <div
        className={`${styles.topGradient} fade-in ${isLoaded ? "loaded" : ""}`}
      ></div>

      {/* 하단 그라데이션 오버레이 (검정만 유지, 빨간 글로우 제거) */}
      <div
        className={`${styles.bottomGradient2} fade-in ${
          isLoaded ? "loaded" : ""
        }`}
        style={{
          opacity: isLoaded ? 1 : 0,
        }}
      ></div>

      <div className={`${styles.content} fade-in ${isLoaded ? "loaded" : ""}`}>
        {/* 상단 영역 */}
        <div className={styles.topSection}>
          <div className={styles.titleSection} style={fadeStyle(0)}>
            <img
              src={mainTitle}
              alt="G2A 2026 부흥을 위한 기도제목"
              className={styles.titleLogo}
            />
          </div>
        </div>

        {/* 하단 영역 */}
        <div className={styles.bottomSection}>
          <div className={styles.buttonSection} style={fadeStyle(0.25)}>
            <button onClick={handleStartClick} className={styles.startButton}>
              <img
                src={buttonSvg}
                alt="기도제목받기"
                className={styles.buttonImage}
              />
            </button>
          </div>

          <div
            className={styles.captionSection}
            style={fadeStyle(0.4)}
            onClick={onCaption}
          >
            <span className={styles.captionText}>
              2026 G2A in KINTEX 집회 예매하기
            </span>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MainPage;
